import { trackEvent, trackPage } from './ui-analytics';
export { trackEvent, trackPage };
